document.addEventListener('DOMContentLoaded', function() {
    const navForms = document.querySelectorAll('[id^="product-form-nav-"]');
    navForms.forEach(navForm => {
    if (!navForm) return;

    function updateNavForm(variantId) {
        if (!variantId) return;
        const navVariantInputs = navForm.querySelectorAll('input[name="id"]');
        navVariantInputs.forEach(input => input.value = variantId);

        const price = window.variantPrices?.[variantId];
        if (price) {
        const navButton = navForm.querySelector('.eva-submit-button-span');
        if (navButton) {
            navButton.setAttribute('data-total', price);
            navButton.textContent = 'Add to cart - $' + price;
        }
        }
    }

    // Default load: get main form variant
    // Target the main product form explicitly — upsell forms earlier in the DOM share data-type="add-to-cart-form"
    const mainForm = document.querySelector('form[id^="product-form-"][id$="__main"]');
    const selectedVariantInput = mainForm?.querySelector('input[name="id"]');
    if (selectedVariantInput) updateNavForm(selectedVariantInput.value);

    // Listen for variant/configuration changes
    document.addEventListener('change', function(event) {
        const target = event.target;
        if (target.name === 'id' || target.name === 'Configuration') {
        const parentForm = target.closest('form');
        if (parentForm && parentForm === mainForm) {
            const variantId = target.name === 'id' ? target.value : parentForm.querySelector('input[name="id"]').value;
            updateNavForm(variantId);
        }
        }
    }, true);
    });
});